// extracted by mini-css-extract-plugin
export default {"img":"index_img_atszH","modal":"index_modal_TQCTx"};